import { datadogRum } from '@datadog/browser-rum';
import type { ReactNode } from 'react';
import React from 'react';

interface ErrorBoundaryProps {
	children: ReactNode;
	fallback: ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
}

export class ErrorBoundary extends React.Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	// Runs when an error is thrown
	static getDerivedStateFromError(_: Error): ErrorBoundaryState {
		return { hasError: true };
	}

	// Optional: log error info
	componentDidCatch(error: Error, info: React.ErrorInfo) {
		console.error('Error caught in ErrorBoundary:', error);
		console.error('Component stack:', info.componentStack);
		datadogRum.addError(error, {
			source: 'custom',
			componentStack: info.componentStack,
		});
	}

	render() {
		const { hasError } = this.state;
		const { fallback, children } = this.props;
		return hasError ? fallback : children;
	}
}
